import { FC, useState, ChangeEvent } from 'react';

interface Props {
  onNext: () => void;
}

const OTPVerification: FC<Props> = ({ onNext }) => {
  const [otp, setOtp] = useState<string[]>(new Array(6).fill(""));

  const handleChange = (e: ChangeEvent<HTMLInputElement>, index: number) => {
    const { value } = e.target;
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && e.target.nextSibling instanceof HTMLInputElement) {
      e.target.nextSibling.focus();
    }
  };

  const handleSubmit = () => {
    const enteredCode = otp.join('');
    console.log('Entered OTP:', enteredCode);
    // Call verify OTP API here
    onNext();
  };

  return (
    <div className="auth-container">
      <h2>wizkind</h2>
      <p className="font-semibold">Enter security code</p>
      <p>Enter the 6-digit code sent to your email</p>

      <div className="otp-box">
        {otp.map((digit, i) => (
          <input
            key={i}
            type="text"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(e, i)}
            className="otp-input"
          />
        ))}
      </div>

      <button onClick={handleSubmit} className="btn-primary">Continue</button>
    </div>
  );
};

export default OTPVerification;
